module.exports = __webpack_public_path__ + "static/Continental-d23643825765aaf09190f12464d78fc1.png";